<template>
  <div>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{setTitleModal(externalAction)}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="dialog = false" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step
              :complete="e1 > 1"
              :step="1"
              @click="setStep(1)"
              class="cursor"
            >{{$t('personalData')}}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="e1 > 2"
              :step="2"
              @click="setStep(2)"
              class="cursor"
            >{{$t('accountData')}}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md3 sm6 xs12>
                      <v-text-field
                        :rules="[v => rules.vacio(v,'name')]"
                        required
                        v-model="name"
                        :disabled="!Edit"
                        autocomplete="new-text"
                        browser-autocomplete
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('name')}}
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex md2 sm6 xs12>
                      <v-text-field
                        :rules="[v => rules.vacio(v,'lastname')]"
                        required
                        v-model="surname"
                        :disabled="!Edit"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('lastname')}}
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex md2 sm6 xs12>
                      <v-text-field v-model="surname2" :disabled="!Edit">
                        <template slot="label">{{$t('lastname2')}}</template>
                      </v-text-field>
                    </v-flex>
                    <v-flex md3 sm6 xs12>
                      <v-text-field
                        :type="showPassword ? 'text' : 'password'"
                        :label="$t('password')"
                        v-model="password"
                        :disabled="!Edit"
                        counter
                        :rules="[v => !v ? true : rules.min(v)]"
                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md1 sm6 xs12>
                      <v-switch v-model="active" :label="$t('active')" color="primary"></v-switch>
                    </v-flex>
                    <v-flex md1 sm6 xs12>
                      <v-switch v-model="validated" :label="$t('validated')" color="primary"></v-switch>
                    </v-flex>
                    <v-flex sm4 xs12>
                      <v-select
                        :disabled="!Edit"
                        :items="geners"
                        v-model="sex"
                        required
                        :rules="[v => rules.vacio(v,'sex')]"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('sex')}}
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex sm4 xs12>
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        full-width
                        lazy
                        min-width="290px"
                        offset-y
                        ref="menu"
                        transition="scale-transition"
                        v-model="menu"
                      >
                        <v-text-field
                          :disabled="!Edit"
                          prepend-icon="event"
                          readonly
                          slot="activator"
                          v-model="date"
                        >
                          <template slot="label">{{$t('birthdayDate')}}</template>
                        </v-text-field>
                        <v-date-picker
                          :disabled="!Edit"
                          :max="new Date().toISOString().substr(0, 10)"
                          @change="save"
                          min="1950-01-01"
                          ref="picker"
                          v-model="date"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex sm4 xs12>
                      <v-text-field
                        :rules="[v => rules.vacio(v,'email'), rules.email]"
                        required
                        v-model="email"
                        :disabled="!Edit"
                        autocomplete="new-text"
                        browser-autocomplete
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('email')}}
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-autocomplete
                        :disabled="!Edit"
                        :items="listCountries"
                        :rules="[v => rules.vacio(v,'country')]"
                        persistent-hint
                        prepend-icon="mdi-city"
                        v-model="country"
                        autocomplete="new-text"
                        browser-autocomplete
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('select', {field
                          :$tc('country') })}}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-autocomplete
                        :disabled="!Edit || country===''"
                        :items="listProvinces"
                        :rules="[v => rules.vacio(v,'province')]"
                        persistent-hint
                        prepend-icon="mdi-city"
                        v-model="province"
                        autocomplete="new-text"
                        browser-autocomplete
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('select', {field
                          :$tc('province') })}}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-autocomplete
                        :disabled="!Edit || province===''"
                        :items="listCities"
                        :rules="[v => rules.vacio(v,'town')]"
                        persistent-hint
                        prepend-icon="mdi-city"
                        v-model="city"
                        autocomplete="new-text"
                        browser-autocomplete
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('select', {field :$tc('town')
                          })}}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-text-field
                        :label="$t('address')"
                        v-model="address"
                        :disabled="!Edit"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-text-field
                        :label="$t('cp')"
                        v-model="cp"
                        :disabled="!Edit"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-text-field
                        :label="$t('phone')"
                        v-model="phone"
                        :disabled="!Edit"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-text-field :disabled="true" prepend-icon="attach_file" v-model="titleFile">
                        <template slot="label">{{$t('userImage')}}</template>
                      </v-text-field>
                      <upload-button
                        :fileChangedCallback="fileChanged"
                        :title="titleButton"
                        :disabled="!Edit"
                      />
                    </v-flex>
                    <v-flex md4 sm6 v-if="image" xs12>
                      <div style="max-width: 200px">
                        <!--<img :src="image" width="100%"/>-->
                        <clipper-preview class="basic md" name="preview"></clipper-preview>
                      </div>
                    </v-flex>
                    <v-flex md4 sm6 v-if="image && Edit" xs12>
                      <div style="max-width: 200px">
                        <clipper-basic :src="image" class="basic lg" preview="preview"></clipper-basic>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout :key="'rols'+ index" v-for="(item, index) in rolsSelect" wrap>
                    <v-flex md4 sm6 xs12>
                      <v-autocomplete
                        :disabled="!Edit || !can('assign', 'role')"
                        :items="filteredRoleList"
                        :rules="[v => rules.vacio(v,'role')]"
                        persistent-hint
                        prepend-icon="mdi-city"
                        v-model="item.rol"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('select', {field :$tc('role')
                          })}}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 sm6 xs12>
                      <v-autocomplete
                        :disabled="!Edit || !statusRol(item.rol) || !can('assign', 'role')"
                        :items="listOthers(item.rol)"
                        :multiple="true"
                        :rules="[v => rules.vacio(v, rolType(item.rol))]"
                        persistent-hint
                        prepend-icon="mdi-city"
                        v-model="item.other"
                        @change="item.search = ''"
                        :search-input.sync="item.search"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{$t('select', {field
                          :$tc(rolType(item.rol)) })}}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <template v-if="can('assign', 'role')">
                      <v-flex md1 sm1 xs1>
                        <v-btn @click="addRol()" color="success" dark fab small>
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex md1 sm1 v-if="rolsSelect.length > 1" xs1>
                        <v-btn @click="removeRol()" color="error" dark fab small>
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card-actions>
          <span style="color:red">*</span>
          <span>{{$t('messages.fieldRequired')}}</span>
          <v-spacer></v-spacer>

          <v-btn
            @click="e1 = 1"
            color="primary"
            small
            v-if="e1 === '2' || e1 === 2"
          >{{$t('previous')}}</v-btn>
          <v-btn @click="resetForm()" color="warning" small>{{$t('reset')}}</v-btn>
          <v-btn
            @click="enviarForm()"
            color="success"
            :loading="loading"
            small
            v-if="(e1==='2' || e1===2) && externalAction === 'create' && can('create', 'user')"
          >{{$t('save')}}</v-btn>
          <v-btn
            @click="updateForm()"
            color="secondary"
            :loading="loading"
            small
            v-if="(e1==='2' || e1===2) && externalAction === 'update' && can('edit', 'user', externalUser)"
          >{{$t('update')}}</v-btn>
          <v-btn
            @click="removeForm()"
            color="error"
            :loading="loading"
            small
            v-if="(e1==='2' || e1===2) && externalAction === 'remove' && can('delete', 'user', externalUser)"
          >{{$t('delete')}}</v-btn>
          <v-btn
            @click="nextStep()"
            color="success"
            small
            v-if="e1 === '1' || e1 === 1"
          >{{$t('next')}}</v-btn>
          <v-btn @click="dialog = false" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import queueToast from '../../../helpers/queueToast'
import { clipperBasic, clipperPreview } from 'vuejs-clipper'
import rules from '../../../helpers/rules'

export default {
  name: 'formManager',
  components: {
    UploadButton,
    clipperBasic,
    clipperPreview
  },
  mixins: [rules],
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false
    },
    externalUser: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    externalAction: {
      type: String,
      required: false,
      default: 'create'
    },
    Edit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      geners: [
        {
          text: 'Hombre',
          value: 'male'
        },
        {
          text: 'Mujer',
          value: 'female'
        }
      ],
      e1: 1,
      notifications: false,
      sound: true,
      widgets: false,
      date: null,
      menu: false,
      country: '',
      province: '',
      city: '',
      image: '',
      file: '',
      titleFile: '',
      name: '',
      surname: '',
      surname2: '',
      password: '',
      showPassword: false,
      sex: '',
      address: '',
      cp: '',
      active: true,
      validated: true,
      phone: '',
      email: '',
      rolsTemplate: {
        rol: '',
        other: []
      },
      rolsSelect: []
    }
  },
  mounted() {
    this.updateAction()
  },
  watch: {
    externalAction: function(val) {
      this.updateAction()
    },
    externalUser: function(val) {
      this.updateAction()
    },
    menu(val) {
      val && this.nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    country: function(val) {
      this.province = ''
    },
    province: function(val) {
      this.city = ''
    }
  },
  computed: {
    ...mapState({
      userId: state => state.users.idSelected,
      listAllRols: state => state.rols.list,
      listEntities: state => state.entities.listSelectEntities,
      listTeams: state => state.teams.listSelectTeams,
      listSelectUsers: state => state.users.listSelectUsers,
      userRolePermissions: state => state.permissions.userRolePermissions,
      listTournaments: state => state.tournaments.listSelect
    }),
    ...mapGetters({
      listCountries: 'countries/selectList',
      listAllProvinces: 'provinces/selectList',
      listRols: 'rols/selectList',
      listAllCities: 'cities/selectList'
    }),
    filteredRoleList() {
      if (this.isAdmin) return this.listRols
      else {
        let roleIds = this.listAllRols
          .filter(role => {
            return (
              (role.type != 'all' &&
                role.type != 'entities' &&
                role.type != 'tournaments' &&
                role.type != 'matches') ||
              this.rolsSelect.some(roleSelect => roleSelect.rol == role._id)
            )
          })
          .map(role => role._id)

        return this.listRols.filter(role => roleIds.includes(role.value))
      }
    },
    listProvinces() {
      if (!this.country) return []
      let me = this
      return this.listAllProvinces.filter(item => item.meta === me.country)
    },
    listCities() {
      if (!this.province) return []
      let me = this
      return this.listAllCities.filter(item => item.meta === me.province)
    },
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.resetForm()
          this.e1 = 1
          this.$emit('close')
        }
      }
    },
    titleButton() {
      return this.image
        ? this.$t('change', { field: this.$t('image') })
        : this.$t('upload', { field: this.$t('image') })
    }
  },
  methods: {
    ...mapActions({
      setUserNew: 'users/setCreateNew',
      setUpdate: 'users/setUpdateUser',
      setRemove: 'users/setDeleteUser'
    }),
    setStep(step) {
      if (this.externalUser._id) {
        this.e1 = step
      }
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    customFilter() {
      /** * A revision ***/
    },
    fileChanged(file) {
      if (file.size < 1) return
      this.createImage(file)
    },
    createImage(file) {
      this.file = file
      this.titleFile = file.name
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    updateAction() {
      switch (this.externalAction) {
        case 'update':
        case 'remove':
          this.updateUser()
          this.Edit = this.externalAction === 'update'
          break
        default:
          this.resetForm()
          this.Edit = true
      }
    },
    updateUser() {
      if (Object.keys(this.externalUser).length === 0) {
        this.resetForm()
        return
      }
      const User = this.externalUser
      this.name = User.name
      this.e1 = 1
      if (User.birthdayDate)
        this.date = User.birthdayDate.toString().substr(0, 10)
      this.country = User.country
      const me = this
      setTimeout(function() {
        me.province = User.province
      }, 20)
      setTimeout(function() {
        me.city = User.town
      }, 20)
      this.image = User.photo
      this.file = ''
      this.titleFile = User.photo
      this.surname = User.lastname1
      this.surname2 = User.lastname2
      this.sex = User.gender
      this.email = User.email
      this.address = User.address
      this.cp = User.cp
      this.phone = User.telf
      this.rolsSelect = []
      this.password = User.password
      this.active = User.active
      this.validated = User.validated
      if (User.roles) {
        User.roles.forEach(item => {
          let ObjectIds = []
          if (Array.isArray(item.objectId)) {
            ObjectIds = item.objectId
          } else {
            ObjectIds.push(item.objectId)
          }
          me.rolsSelect.push({
            rol: item.roleId,
            other: ObjectIds
          })
        })
      } else {
        console.log('sin rol')
        this.rolsSelect.push(Object.assign({}, this.rolsTemplate))
      }
    },
    resetForm() {
      this.e1 = 1
      this.date = null
      this.country = ''
      this.province = ''
      this.city = ''
      this.image = ''
      this.file = ''
      this.titleFile = ''
      this.name = ''
      this.surname = ''
      this.surname2 = ''
      this.sex = ''
      this.address = ''
      this.email = ''
      this.cp = ''
      this.phone = ''
      this.password = ''
      this.active = true
      this.validated = true
      this.rolsSelect.splice(0, this.rolsSelect.length)
      this.rolsSelect.push(Object.assign({}, this.rolsTemplate))
    },
    addRol() {
      this.rolsSelect.push(Object.assign({}, this.rolsTemplate))
    },
    removeRol() {
      if (this.rolsSelect.length > 1) {
        this.rolsSelect.splice(this.rolsSelect.length - 1, 1)
      }
    },
    rolById(id) {
      return this.listAllRols.find(item => item._id === id)
    },
    statusRol(id) {
      const rol = this.rolById(id)
      if (!rol) {
        return true
      }
      return rol.type !== 'all'
    },
    listOthers(id) {
      const rol = this.rolById(id)
      if (!rol || !rol.type) return
      switch (rol.type) {
        case 'entities':
          return this.listEntities
        case 'teams':
        case 'participant':
          return this.listTeams
        case 'tournaments':
          return this.listTournaments
        case 'matches':
        case 'users':
          return this.listSelectUsers
      }
    },
    rolType(id) {
      const rol = this.rolById(id)
      if (!rol || !rol.type) return
      switch (rol.type) {
        case 'entities':
          return 'entity'
        case 'teams':
        case 'participant':
          return 'team'
        case 'tournaments':
          return 'tournament'
        case 'matches':
          return 'match'
        case 'users':
          return 'user'
      }
    },
    errorFormPaso1() {
      let error = false
      let message = []
      let isResponse = false
      /* if (!this.date) {
        error = true
        message.push('No ha ingresado la fecha de nacimiento')
      } */
      if (!this.name && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('name') }))
        isResponse = true
      }
      if (!this.surname && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('lastname') }))
        isResponse = true
      }
      if (!this.sex) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('sex') }))
      }
      if (!this.email && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('email') }))
        isResponse = true
      }
      if (!this.country && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('country') }))
        isResponse = true
      }
      if (!this.province && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('province') }))
        isResponse = true
      }
      if (!this.city && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('town') }))
        isResponse = true
      }
      return {
        error,
        message
      }
    },
    errorFormPaso2() {
      let error = false
      let message = []
      const me = this
      this.rolsSelect.forEach(item => {
        if (item.rol) {
          // if (me.statusRol(item.rol)) {
          //   if (item.other.length === 0) {
          //     const tempRol = me.rolById(item.rol)
          //     error = true
          //     message.push(this.$t('error.roleError') + tempRol.name)
          //   }
          // }
        } else {
          error = true
          message.push(this.$t('error.rolesIncomplete'))
        }
      })
      return {
        error,
        message
      }
    },
    validarFormPaso1() {
      const paso1 = this.errorFormPaso1()
      if (paso1.error) {
        queueToast(paso1.message)
      }
      return !paso1.error
    },
    validarForm() {
      const paso1 = this.errorFormPaso1()
      if (paso1.error) {
        queueToast(paso1.message)
        return false
      }
      const paso2 = this.errorFormPaso2()
      if (paso2.error) {
        queueToast(paso2.message)
        return false
      }
      return true
    },
    createUser() {
      let rolesEnvio = []
      this.rolsSelect.forEach(item => {
        rolesEnvio.push({
          roleId: item.rol,
          objectId: item.other,
          confirm: true
        })
      })
      return {
        deleted: false,
        email: this.email,
        password: this.password,
        telf: this.phone,
        birthdayDate: this.date,
        gender: this.sex,
        roles: rolesEnvio,
        register: 'backoffice',
        name: this.name,
        lastname1: this.surname,
        lastname2: this.surname2,
        countryId: this.country,
        provinceId: this.province,
        townId: this.city,
        address: this.address,
        cp: this.cp,
        photo: this.file,
        active: this.active,
        validated: this.validated
      }
    },
    enviarForm() {
      if (!this.validarForm() || this.loading) {
        return
      }

      let user = this.createUser()
      this.loading = true
      this.setUserNew(user)
        .then(result => (this.dialog = false))
        .finally(_ => (this.loading = false))
    },
    updateForm() {
      if (!this.validarForm() || this.loading) {
        return
      }

      let user = this.createUser()
      user._id = this.externalUser._id
      this.loading = true
      this.setUpdate(user)
        .then(result => (this.dialog = false))
        .finally(_ => (this.loading = false))
    },
    removeForm() {
      if (!this.validarForm() || this.loading) {
        return
      }

      let _id = this.externalUser._id
      this.loading = true
      this.setRemove(_id)
        .then(result => (this.dialog = false))
        .finally(_ => (this.loading = false))
    },
    nextStep() {
      if (this.validarFormPaso1()) {
        this.e1 = 2
      }
    },
    setTitleModal(type) {
      switch (type) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('user') })
        case 'remove':
          return this.$t('deleteModel', { field: this.$tc('user') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('user') })
      }
    }
  }
}
</script>
<style scoped>
.cursor:hover {
  cursor: pointer;
}
</style>
